import { Link, Route, Routes } from 'react-router-dom';
import { AppLayout } from './components/layout/app-layout';
import { ProtectedRoute } from './components/protected-route';
import { YoutubeStagePage } from './pages/youtube-stage';
import { DashboardPage } from './pages/dashboard';
import { GuestJoinPage } from './pages/guest-join';
import { LiveDetailPage } from './pages/live-detail';
import { PrivacyPage, TermsPage } from './pages/legal';
import { HomePage } from './pages/home';
import { LoginPage } from './pages/login';
import { ShowDetailPage } from './pages/show-detail';
import { StudioPage } from './pages/studio';

function NotFoundPage() {
  return (
    <div className="empty-state">
      <h2>Page not found</h2>
      <p className="muted">That address does not match anything in LiveForge.</p>
      <Link className="button button--primary" to="/">
        Back to homepage
      </Link>
    </div>
  );
}

export function App() {
  return (
    <Routes>
      {/* Public. The guest route deliberately sits outside ProtectedRoute so an
          invite link never bounces an unauthenticated visitor to /login. */}
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/guest/:token" element={<GuestJoinPage />} />
      {/*
        The player tab. Outside ProtectedRoute on purpose: it is opened by a
        host who is already signed in, it reads nothing but a video id from the
        query string, and putting an auth redirect in front of a surface that
        exists to be screen-captured would eventually capture a login screen.
      */}
      <Route path="/youtube" element={<YoutubeStagePage />} />
      {/*
        Public, and they have to stay that way: Google requires the privacy
        policy to be readable without signing in, on the same domain as the
        homepage, and linked from it. A policy behind a login is a policy the
        reviewer cannot reach.
      */}
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/shows/:showId" element={<ShowDetailPage />} />
          <Route path="/lives/:liveId" element={<LiveDetailPage />} />
        </Route>
        {/* Outside AppLayout: the studio owns the whole viewport. */}
        <Route path="/lives/:liveId/studio" element={<StudioPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
